<template>
<div class="my">
    <div class="title">
      <div class="top w clearfix">
        <p class="fl">河南省全科医学培训中心</p>
        <p class="fr xiaoshou">
          <span class="spn1" @click="personal" >个人中心</span>
          <span @click="goback">退出</span>
        </p>
      </div>
    </div>
  <div class="packagedetail">
    <div class="topbox coursebg">
      <div class="wrap">
        <div class="coursetopbox">
          <div class="left">
            <img
              :src="imgs"
              alt="国际商务与国际营销(43课时)"
            />
          </div>

          <div class="right">
            <h3>{{title}}({{xueshi}}课时)</h3>
            <div class="coursetopitem">可得学时：{{xueshi}}学时</div>
            <!-- <div class="coursetopitem">适合区域：河南省</div> -->
            <div class="coursetopitem">年份：{{year}}</div>
            <!-- <div class="coursetopitem">
              <div class="fl">价格：</div>
              <div class="new_price">
                <span>¥{{price}}元</span>
              </div>
            </div>-->
              <button @click="xuexi()" class="pres_btn">开始学习</button>
             <!-- <button class="pres_btn" @click="nowbuy" v-model="id" v-if="id=='0'">立即购买</button>
             <button class="pres_btn" v-else>已购买</button>
             <el-button type="primary" disabled class="pres_btn" v-model="id">{{id==0?"已购买":"立即购买"}}</el-button> -->
            <!-- <div class="coursetopitem btn">
              <span id="charge_video" class="buy" @click="gopackdetail">购买</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="wrap course_album">
        <div class="coursemain">
          <div class="coursemain-hd" id="view_main_nav">
            <ul>
              <li class="on">
                <i class="icon-02"></i>套餐课程目录
              </li>
            </ul>
          </div>

          <!-- 班级简介 -->
          <div class="coursemain-bd" style="display:none;">
            <div class="coursemain_con">国际商务与国际营销国际商务与国际营销国际商务与国际营销国际商务与国际营销国际商务与国际营销</div>
          </div>
          <!-- 班级包含课程 -->
          <div class="coursemain-bd" style="display: block;">
            <div class="coursemain_con">
              <ul class="coursemainlist">
                <li v-for="item in data" :key="item.id" @click="coursedetail(item.id)">
                    <img
                      :src="item.img_url"
                    />
                  <h3>{{item.title}}</h3>
                  <!-- <p class="p_price">价格：{{item.price}}元</p> -->
                  <div class="info">课程学时：{{item.xueshi_num}}学时</div>
                  <p><span>主讲:&nbsp;</span><span>{{item.jiangshi.name}}</span></p>
                  <p><span>课程状态：</span><span>{{item.is_finish=='0'?'未完成':'已完成'}}</span></p>
                </li>
              </ul>
            </div>
          </div>
          <!-- 班级评论 -->
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
  <foot></foot>
</div>
</template>

<script>
import qs from 'qs'
import foot from '@/components/footer';
export default {
  name:'personalpackage',
  components:{
      foot,
  },
  data() {
    return {
        codeid:'',
        data:[],
        price:'',
        xueshi:'',
        uid:'',
        token:'',
        year:'',
        imgs:'',
        title:'',
        idd:'',
        token:localStorage.getItem("token"),
        
        id:'',
        bol:false,
        boll:true
    };
  },

  created() {
    this.uid=localStorage.getItem('uid')
    this.token=localStorage.getItem('token')
    if(localStorage.getItem("token")){
      this.codeid=this.$route.query.codeid
      // this.codeid=this.$route.params.codeid
      //  (this.codeid)
      this.getkechengbao()
    }else{
       this.removeInfo();
    }
    this.$axios.post('/kecheng/kecheng_is_finish')
  },
  watch: {
		token: {
			handler: function(val) {
            if (val) {

            }else{
              this.removeInfo()
            }
			}
		},deep:true
  },
  mounted(){
    this.money();
  },
  methods: {
    xuexi(){
      var href = window.location.href.split('?')[1];
      var codeid = href.split('=')[1];
      this.$axios.post('/kecheng/get_kecheng_list_for_kechengbao_id',
          qs.stringify({
              kechengbao_id:codeid
          })
          ).then(res =>{
            if(res.data.status=="ok"){
              // ("课程包列表")
               (res.data.data.kecheng[0].id,codeid)
              this.$router.push({
                name:'personcourseDetails',
                params:{
                  courseId:res.data.data.kecheng[0].id,
                },
                query:{
                  codeid:codeid
                }
              });
              // (that.imgs)
              for(var i=0;i<res.data.data.kecheng.length;i++){
                  this.idd=res.data.data.kecheng[i].id
              }
            }else if((res.data.status=="error")){
              this.$message.error({message:res.data.errormsg,duration:1600});
            }else if((res.data.status=="relogin")){
              this.removeInfo();
            }

          })
    },
    //判断是否购买
    money(){
      var href = window.location.href.split('?')[1];
      var codeid = href.split('=')[1];
      // // (codeid)
      let that =this;
      let courseId={kecheng_bao_id:codeid,uid:localStorage.getItem("uid"),token:localStorage.getItem("token")}
      this.$axios.post('/kecheng/check_kecheng_bao_is_buy',qs.stringify(courseId))
      .then(response => {
        // (response)
         (response.data.data.check_res)
        this.id = response.data.data.check_res;
        // (this.id);
        // if(this.id==1){
        //   this.bol = false;
        //   this.boll = true;
        // }
      })
    },
    //购买按钮
    nowbuy(){
        var href = window.location.href.split('?')[1];
        var codeid = href.split('=')[1];
        if(localStorage.getItem("login1")=="1"){
          let that =this;
          let courseId={kecheng_bao_id:codeid,uid:localStorage.getItem("uid"),token:localStorage.getItem("token")}
          this.$axios.post('/kecheng/check_kecheng_bao_is_buy',qs.stringify(courseId))
          .then(response => {
            this.id = response.data.data.check_res;
            // (this.id);
            if(response.data.status=="ok"){
              if(response.data.data.check_res=="0"){
                that.$router.push({ name:'courseBuyDetails',query:{codeid:codeid} });
              }else if(response.data.data.check_res=="1"){
                this.$message.success({message:"您已购买过该课程",duration:1600});
              }
            }else if((response.data.status=="error")){
              // (response);
              this.$message.error({message:response.data.errormsg,duration:1600});
            }else if((response.data.status=="relogin")){
              // (response);
              this.$message.error({message:"重新登录",duration:1600});
              that.removeInfo();
            }

          })
        }else{
          this.loginstate=1;
        }
      },
      getkechengbao (){
          var that=this
          this.$axios.post('/kecheng/get_kecheng_list_for_kechengbao_id',
          qs.stringify({
              kechengbao_id:this.codeid,
              uid:this.uid,
              token:this.token
          })
          ).then(res =>{
            if(res.data.status=="ok"){
              // ("课程包列表")
               (res)
              that.data=that.data.concat(res.data.data.kecheng)
              that.price=res.data.data.price
              that.xueshi=res.data.data.xueshi_num
              that.year=res.data.data.year
              that.imgs=res.data.data.img_url
             // console.log(that.imgs)
              that.title=res.data.data.title
              // (that.imgs)
              for(var i=0;i<res.data.data.kecheng.length;i++){
                  that.idd=res.data.data.kecheng[i].id
              }
            }else if((res.data.status=="error")){
              that.$message.error({message:res.data.errormsg,duration:1600});
            }else if((res.data.status=="relogin")){
              that.removeInfo();
            }

          })
      },
    // gopackdetail (){
    //   this.$router.push({
    //     name:'courseDetails',
    //     params:{
    //         courseId:this.idd
    //     }
    //   })
    // },
    coursedetail(id){
      // (this.$route.query.codeid)
      this.$router.push({
        name:'personcourseDetails',
        params:{
          courseId:id,
        },
        query:{
          codeid:this.$route.query.codeid
        }
      });
    },
    //返回按钮
      goback (){
          var that =this
          this.$axios.post('/user/logout',
           qs.stringify({
             uid:this.uid,
             token:this.token
           })
          ).then(res =>{
            that.tuichusucess();
          })
      },
    //返回个人中心
    personal(){
        this.$router.push({path:'/my'});
    },
    tuichusucess(){
      let that =this ;
      that.$message.success({message:"退出成功",duration:1600});
      localStorage.removeItem("uid");
      localStorage.removeItem("token");
      localStorage.removeItem("sex");
      localStorage.removeItem("name");
      localStorage.removeItem("mobile");
      localStorage.removeItem("id_card");
      setTimeout(() => {
        that.$router.push({ path: '/index' });
      }, 1600);
    },
    removeInfo(){
      let that =this ;
      that.$message.error({message:"重新登录",duration:1600});
      localStorage.removeItem("uid");
      localStorage.removeItem("token");
      localStorage.removeItem("sex");
      localStorage.removeItem("name");
      localStorage.removeItem("mobile");
      localStorage.removeItem("id_card");
      setTimeout(() => {
        that.$router.push({ path: '/' });
      }, 1600);
    },

  },
};
</script>

<style lang="less" scoped>
.my {
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  cursor: default;
  .w {
    width: 1200px;
    margin: 0 auto;
  }

  .title {
    width: 100%;
    height: 72px;
    line-height: 72px;
    background-color: #ad0008;
    color: #fff;
    font-size: 28px;
    letter-spacing: 2px;
    .fr {
      font-size: 16px;
      .spn1 {
        margin-right: 45px;
      }
      span{cursor: pointer;}
    }
  }

  }
.packagedetail {
  width: 100%;
  .title {
    width: 100%;
    height: 72px;
    line-height: 72px;
    background-color: #0169cc;
    color: #fff;
    font-size: 28px;
    letter-spacing: 2px;
    .fr {
      font-size: 16px;
      .spn1 {
        margin-right: 45px;
      }
    }
  }
  .coursebg {
    margin: 15px auto 0;
    background-color: #fff;
    width: 1200px;
  }
  .wrap {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }
  .coursetopbox {
    padding: 20px 0;
  }
  .coursetopbox .left {
    position: relative;
    height: 320px;
    display: inline-block;
    vertical-align: top;
  }
  .coursetopbox .left img {
    width: 580px;
    height: 320px;
    display: block;
    margin-left: 15px;
  }
  .coursetopbox .right {
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin-left: 50px;
    height: 320px;
  }
  .coursetopbox h3 {
    margin-top: 40px;
    margin-bottom: 10px;
    color: #333;
    font-size: 24px;
    line-height: 40px;
  }
  .coursetopbox .info {
    margin-bottom: 20px;
    color: #666;
    line-height: 20px;
  }
  .coursetopitem {
    color: #333;
    font-size: 14px;
    line-height: 30px;
  }
  .coursetopitem {
    color: #333;
    font-size: 14px;
    line-height: 30px;
  }
  .coursetopitem {
    color: #333;
    font-size: 14px;
    line-height: 50px;
  }
  .coursetopitem .fl {
    line-height: 40px;
    font-size: 14px;
  }
  .coursetopitem .new_price {
    float: left;
    margin-right: 30px;
    color: #fb7d30;
  }
  .coursetopitem .new_price span {
    font-size: 24px;
    line-height: 30px;
  }
  .coursetopitem.btn {
    margin-top: 85px;
    float: left;
  }
  .coursetopitem .buy {
    float: left;
    margin-right: 25px;
    width: 204px;
    height: 47px;
    background-color: #e82f24;
    color: #fff;
    text-align: center;
    font-size: 22px;
    line-height: 47px;
  }
  .coursemain {
    // width: 880px;
    background: #fff; // float: left;
  }
  .coursemain-hd {
    font-size: 18px;
  }
  .coursemain-hd ul {
    overflow: hidden;
    margin: 0 15px;
    border-bottom: 1px solid #edf2f2;
    height: 60px;
    line-height: 58px;
    background-color: white;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .coursemain-hd li {
    margin-right: 60px;
    height: 100%;
  }
  .coursemain-hd li a {
    display: block;
    height: 58px;
    color: #666;
    font-size: 18px;
    line-height: 58px;
  }
  .coursemain-hd li .icon-01 {
    background-position: -115px -416px;
  }
  .coursemain-hd li.on a {
    border-bottom: solid 2px #e82f24;
    color: #e82f24;
  }
  .coursemain-bd {
    padding: 20px 15px;
  }
  .coursemain-bd .coursemain_con {
    font-size: 14px;
    line-height: 20px;
    color: #666;
    text-indent: 28px;
  }
  .coursemainlist li {
    // position: relative;
    padding: 25px 30px 25px 170px; // height: 78px;
    border-bottom: solid 1px #e2e2e2; //  border: 1px solid red;
    cursor: pointer;
  }
  .coursemainlist li > a {
    display: block;
    color: #000;
  }
  .coursemainlist li h3 {
    margin-bottom: 10px;
  }
  .coursemainlist li h3 a {
    font-size: 18px;
    display: block;
    color: #333;
  }
  .coursemainlist img {
    position: absolute;
    margin-left: -170px;
    width: 140px;
    height: 95px;
  }
  .coursemainlist p {
    color: #999;
    font-size: 13px;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .coursemainlist .p_price {
    font-size: 13px;
    color: #333;
  }
  .coursemainlist .info {
    font-size: 13px;
    color: #999;
  }
}
.pres_btn{
  padding: 10px 20px;
  color: #fff;
  background: #F00;
  font-size: 16px;
  border-radius: 5px;
  position: absolute;
  top: 247px;
  left:6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/personalpackage.vue